import { Container } from "reactstrap";
import { ToastContainer, BackLink } from "../../components/Common";
import WorkSessionsDetailsPage from "./page";

const WorkSessionsDetailsWrapper = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <BackLink />
                <WorkSessionsDetailsPage />
            </Container>
            <ToastContainer />
        </div>
    );
};

export default WorkSessionsDetailsWrapper;
